import {useState} from 'react';

import {User} from 'api/types/userTypes';
import {useSelector} from 'react-redux';
import {selectManageUser} from 'store/selectors';

export const useData = () => {
  const {loading, data, userType} = useSelector(selectManageUser);

  return {
    loading,
    data,
    userType,
  };
};

export const useModal = (data?: User[]) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState<User>();

  const onShowModal = () => setShowModal(!showModal);

  const onClick = (selectedId?: string) => () => {
    setSelectedUser(data?.find(({id}) => id === selectedId));
    onShowModal();
  };

  return {
    showModal,
    selectedUser,
    onShowModal,
    onClick,
  };
};
